//Handle load-more-button
(function () {
  document.addEventListener("click", function (e) {
    if (e.target.closest(".js-load-more")) {
      const loadMoreBtn = e.target.closest(".js-load-more");
      const product_on_page = document.querySelector(".product-grid");
      const next_url = product_on_page.dataset.nextUrl;
      const product_count = document.querySelector(
        "[data-products-current-count]",
      );
      const loadmore_wrap = loadMoreBtn.closest(".load-more__wrap");

      setTimeout(() => {
        const content = product_on_page.innerHTML;
        const productCurrentCountContent = product_count.innerHTML;
        sessionStorage.setItem(
          `cacheContentCollection-${window.collectionHandle}`,
          content,
        );
        sessionStorage.setItem(
          `cacheCurrentCountCollection-${window.collectionHandle}`,
          productCurrentCountContent,
        );
        sessionStorage.setItem(
          `cacheLoadMoreBtnCollection-${window.collectionHandle}`,
          loadmore_wrap.innerHTML,
        );
      }, 2e3);

      fetch(next_url, {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
        },
      })
        .then((response) => response.text())
        .then((next_page) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(next_page, "text/html");
          const new_products = doc.querySelector(".product-grid");
          const new_url = new_products.dataset.nextUrl;
          const total_page = new_products.dataset.totalPage;
          const current_page = new_products.dataset.currentPage;
          const number_total_page = parseInt(total_page);
          const number_current_page = parseInt(current_page);
          const new_product_count = doc.querySelector(
            "[data-products-current-count]",
          );

          product_on_page.dataset.nextUrl = new_url;
          product_on_page.insertAdjacentHTML(
            "beforeend",
            new_products.innerHTML,
          );
          product_on_page.setAttribute("data-current-page", current_page);

          if (number_current_page >= number_total_page) {
            loadMoreBtn.classList.add("hide");
          }

          product_count.innerHTML = new_product_count.innerHTML;
          document.body.dispatchEvent(new CustomEvent("initTheWishlist"));
          document.dispatchEvent(new CustomEvent("handleProductBadges"));
          sessionStorage.setItem(
            `cacheNextUrl-${window.collectionHandle}`,
            new_url,
          );
          sessionStorage.setItem(
            `cacheCurrentPageContent-${window.collectionHandle}`,
            current_page,
          );
        });
    }
  });
})();

// Handle first load when click on load more button
(function () {
  window.addEventListener("beforeunload", () => {
    if (
      window.location.pathname.includes(
        `/collections/${window.collectionHandle}`,
      )
    ) {
      sessionStorage.setItem(
        `scrollPosition-${window.collectionHandle}`,
        window.scrollY.toString(),
      );
    }
  });

  // For iphone
  document.addEventListener("visibilitychange", () => {
    if (
      window.location.pathname.includes(
        `/collections/${window.collectionHandle}`,
      )
    ) {
      sessionStorage.setItem(
        `scrollPosition-${window.collectionHandle}`,
        window.scrollY.toString(),
      );
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    // For collection page
    if (
      window.location.pathname.includes(
        `/collections/${window.collectionHandle}`,
      )
    ) {
      const productGridCollection = document.getElementById("product-grid");
      const productCurrentCountCollection = document.querySelector(
        "#ProductGridContainer [data-products-current-count]",
      );
      const loadMoreWrap = document.querySelector(".load-more__wrap");
      const content = sessionStorage.getItem(
        `cacheContentCollection-${window.collectionHandle}`,
      );
      const productCurrentCountContent = sessionStorage.getItem(
        `cacheCurrentCountCollection-${window.collectionHandle}`,
      );
      const currentPageContent = sessionStorage.getItem(
        `cacheCurrentPageContent-${window.collectionHandle}`,
      );
      const nextUrlContent = sessionStorage.getItem(
        `cacheNextUrl-${window.collectionHandle}`,
      );
      const loadMoreContent = sessionStorage.getItem(
        `cacheLoadMoreBtnCollection-${window.collectionHandle}`,
      );

      if (productGridCollection && content) {
        productGridCollection.innerHTML = content;
        productGridCollection.setAttribute("data-next-url", nextUrlContent);
        productGridCollection.setAttribute(
          "data-current-page",
          currentPageContent,
        );
      }

      if (productCurrentCountCollection && productCurrentCountContent) {
        productCurrentCountCollection.innerHTML = productCurrentCountContent;
      }

      if (loadMoreWrap && loadMoreContent) {
        loadMoreWrap.innerHTML = loadMoreContent;
      }
    }

    if (
      !window.location.pathname.includes("collections") &&
      !window.location.pathname.includes("products")
    ) {
      removeItemFromSessionstorage("scrollPosition-");
      removeItemFromSessionstorage("cacheContentCollection-");
      removeItemFromSessionstorage("cacheCurrentPageContent-");
      removeItemFromSessionstorage("cacheNextUrl-");
      removeItemFromSessionstorage("cacheCurrentCountCollection-");
      removeItemFromSessionstorage("cacheCountCollection-");
      removeItemFromSessionstorage("cacheLoadMoreBtnCollection-");
    }

    const scrollPosition = sessionStorage.getItem(
      `scrollPosition-${window.collectionHandle}`,
    );
    if (
      window.location.pathname.includes(
        `/collections/${window.collectionHandle}`,
      ) &&
      scrollPosition !== null
    ) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(scrollPosition));
      }, 450);
    }

    function removeItemFromSessionstorage(keyString) {
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        setTimeout(() => {
          if (key && key.includes(keyString)) {
            sessionStorage.removeItem(key);
          }
        }, 3e2);
      }
    }
    // End for collection page
  });
})();
